<template>
  <div class="class_list">
    <div class="mask" v-if="guideShow">
      <div
        class="swiper-container swiper-no-swiping"
        :class="{ opacityClass: opacityClass }"
      >
        <div class="swiper-wrapper">
          <div
            v-for="(item, index) in classList"
            class="swiper-slide"
            :key="index"
            :class="{ opacityClass: item.experienceSubType != 26 }"
          >
            <div class="sub_slide novice_class" v-if="index < 10">
              <h2 class="title">{{ item.subjectName }}</h2>
              <div class="grade"></div>
              <div class="content">
                <img :src="item.newBgImg" alt="" />
                <div :class="{ test_student: item.subName }">
                  <h2>{{ item.newName }}</h2>
                </div>
              </div>
            </div>
            <div class="guide" :class="{ 'guide-top': classList.length === 1 }">
              <p>
                点击卡片 <br />
                学习“新手课”，开启学习之旅
              </p>
              <button @click="hideGuide">我知道了</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loadError
      textColor="#fff"
      @loadAgain="getListAgain"
      v-if="loadErrorShow"
    />
    <div
      class="swiper-container swiper-box"
      :class="{ opacityClass: opacityClass }"
    >
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in classList"
          :class="[
            (disPlayInside(item.classStatus, 'lessonIndex') &&
              disPlay(item.grade == null ? 100 : item.grade, 'gradeIndex') &&
              disPlay(item.subject, 'subjectIndex') &&
              disPlay(item.classYear, 'classYear') &&
              disPlay(item.classSeasonId, 'semesterIndex')) ||
            item.experienceSubType == 26
              ? 'show'
              : 'hide',
            'swiper-slide',
            'cursor',
          ]"
          @click="go_course(item)"
          :key="index"
        >
          <div
            :class="[
              classNameConfig[item.subject],
              'sub_slide',
              item.experienceSubType == 26 ? 'novice_class' : '',
            ]"
          >
            <!-- <h2 class="title">{{ item.subjectName }}</h2> -->
            <div class="subject-bg"></div>
            <svg
              class="glow-svg"
              viewBox="0 0 380 380"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <filter
                  :id="'beam-glow-' + index"
                  x="-50%"
                  y="-50%"
                  width="200%"
                  height="200%"
                >
                  <feGaussianBlur stdDeviation="3" result="blur" />
                  <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
                <path
                  :id="'card-path-' + index"
                  d="M0 28Q0 0 28 0H190C211 0 251 72 290 72H352Q380 72 380 100V352Q380 380 352 380H28Q0 380 0 352V28Z"
                />
              </defs>
              <template v-if="item.classStatus == 2">
                <path
                  v-for="(layer, li) in meteorLayers"
                  :key="'t' + li"
                  pathLength="100"
                  fill="none"
                  stroke="#fff"
                  :stroke-width="layer.w"
                  :opacity="layer.o"
                  stroke-linecap="round"
                  d="M0 28Q0 0 28 0H190C211 0 251 72 290 72H352Q380 72 380 100V352Q380 380 352 380H28Q0 380 0 352V28Z"
                  :stroke-dasharray="layer.da"
                >
                  <animate
                    attributeName="stroke-dashoffset"
                    :values="layer.ov"
                    :dur="glowAnimDur"
                    repeatCount="indefinite"
                  />
                </path>
                <polygon
                  points="0,-4 1.2,-1.2 4,-1.2 1.8,0.8 2.8,4 0,2 -2.8,4 -1.8,0.8 -4,-1.2 -1.2,-1.2"
                  fill="#fff"
                  :filter="'url(#beam-glow-' + index + ')'"
                >
                  <animateMotion
                    :dur="glowAnimDur"
                    begin="-0.84s"
                    repeatCount="indefinite"
                    rotate="auto"
                  >
                    <mpath :href="'#card-path-' + index" />
                  </animateMotion>
                </polygon>
              </template>
            </svg>
            <!-- <div class="grade" v-if="item.experienceSubType == 26"></div>
            <div class="grade" v-else-if="[null, 100].includes(item.grade)">
              <img
                src="../../../assets/img/class/star.png"
                alt=""
                style="width: 70%"
              />
            </div> -->

            <!-- <div class="grade" v-else>
              <span>{{
                item.grade == 31 ? "幼" : item.grade == 32 ? "全" : item.grade
              }}</span>
              <br />{{ item.grade == 31 ? "儿园" : "年级" }}
            </div> -->
            <div class="in_class" v-if="item.classStatus == 2">
              <span class="lottie_playing"></span
              ><span class="lottie_playing_text">上课中</span>
            </div>
            <div class="content">
              <img
                :src="`/static/img/subject/${item.subject}.png`"
                :class="`subjectIco${item.subject}`"
              />
              <div :class="{ test_student: item.subName }">
                <h2 class="title">{{ item.subjectName }}</h2>
                <div
                  class="grade"
                  :style="{ opacity: item.grade < 100 ? 1 : 0 }"
                >
                  <!-- {{
                    item.grade == 31
                      ? "幼"
                      : item.grade == 32
                      ? "全"
                      : item.grade
                  }}
                  {{ item.grade == 31 ? "儿园" : "年级" }} -->
                  {{
                    item.grade < 100
                      ? grades[item.grade == null ? 0 : item.grade]
                      : ""
                  }}
                </div>
                <h2 :class="[item.subName ? '' : 'u-single', 'course_title']">
                  {{ item.subName }} {{ item.newName }}
                </h2>
                <h2 class="course_info">
                  <template v-if="item.subName">
                    <span>{{ item.classYear + "年" + item.classTermName }}</span
                    ><span>|</span><span>{{ item.teacherName }}</span
                    ><span>|</span><span>{{ item.classTypeName }}</span
                    ><span>|</span><span>{{ item.frequency }}</span
                    ><span>|</span><span> {{ item.bookVersionName }}</span>
                  </template>
                </h2>
                <p>
                  <img src="/static/img/subject/time.png" alt="" />
                  <span>{{ item.showTime.split(" ")[1] }}</span>
                </p>
              </div>
            </div>
            <!-- <img
              src="../../../assets/img/class/end.png"
              v-if="item.classStatus == 3"
              alt
              class="end"
            /> -->
            <span class="end" v-if="item.classStatus == 3">已结课</span>
          </div>
        </div>
      </div>
    </div>
    <div class="hint" v-if="!hintShow && !loadErrorShow && !isRequest">
      <span
        class="filter_hint"
        v-if="
          gradeIndex ||
          lessonIndex ||
          subjectIndex ||
          classYear == '全部年份' ||
          semesterIndex
        "
        >未找到满足条件的课程</span
      >
      <div v-else>
        <span>暂无课程</span>
        <!-- <p>关注名师火箭班微信服务号了解更多课程信息</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import loadError from "../../basic/loadError";
import { mapState, mapMutations, mapActions } from "vuex";
import common from "common";
import lottie from "lottie-web-limi";
export default {
  name: "class_list",
  data() {
    return {
      classList: [],
      opacityClass: true,
      hintShow: true,
      swiper: null,
      loadErrorShow: false,
      isRequest: false,
      interval: null,
      dataState: [],
      classNameConfig: {
        1: "subject_1",
        2: "subject_2",
        3: "subject_3",
        4: "subject_4",
        5: "subject_5",
        6: "subject_6",
      },
      glowAnimDur: "6s",
      grades: [
        "全部阶段",
        "L1",
        "L2",
        "L3",
        "L4",
        "L5",
        "L6",
        "L7",
        "L8",
        "L9",
        "G1",
        "G2",
        "G3",
      ],
    };
  },
  props: ["guideShow"],
  computed: {
    ...mapState([
      "round_robin_interval",
      "firstLogin",
      "gradeIndex",
      "lessonIndex",
      "subjectIndex",
      "semesterIndex",
      "classYear",
    ]),
    meteorLayers() {
      const n = 20;
      const layers = [];
      for (let i = 0; i < n; i++) {
        const t = i / (n - 1);
        const dash = 14 - t * 13;
        const w = (0.2 + t * 2.8).toFixed(1);
        const o = (0.05 + t * 0.65).toFixed(2);
        const s = 86 + dash;
        const e = dash - 14;
        layers.push({
          da: dash.toFixed(1) + " " + (100 - dash).toFixed(1),
          w,
          o,
          ov: s.toFixed(1) + ";" + e.toFixed(1),
        });
      }
      return layers;
    },
  },
  watch: {
    guideShow(val) {
      if (val) {
        this.$nextTick(() => {
          new Swiper(".swiper-no-swiping", {
            slidesPerView: "auto",
            centerInsufficientSlides: true,
            spaceBetween: 65,
          });
        });
      }
    },
  },
  components: {
    loadError,
  },
  created() {
    this.getList();
  },
  updated() {
    this.swiperupdateSize();
  },
  methods: {
    ...mapActions(["getClassList", "getLessonsState"]),
    ...mapMutations(["saveClassInfo", "refreshNet"]),
    hideGuide() {
      this.$root.eventHub.$emit("showPopup", "guideShow");
    },
    getListAgain() {
      // this.$root.eventHub.$emit("createLog", {
      //   id: "LMTrackEventFailureButton"
      // });
      this.getList();
    },
    getState() {
      this.getLessonsState({
        classIds: this.dataState,
        roundRobinInterval: this.round_robin_interval,
      }).then(({ res, ok }) => {
        if (!ok || !res || !res.length) return;
        this.getList(false);
      });
    },
    getList(needLoading = true) {
      this.loadErrorShow = false;
      this.isRequest = true;
      this.dataState = [];
      this.getClassList({
        data: {
          client: common.client,
          version: common.version,
          firstLoginCheck: this.firstLogin,
        },
        config: {
          needLoading: needLoading,
        },
      })
        .then(
          ({ res, ok }) => {
            this.isRequest = false;
            if (!ok) {
              this.classList = [];
              this.loadErrorShow = true;
              return;
            }
            this.classList = res;
            this.$parent.getClassList(this.classList);
            setTimeout(() => {
              this.opacityClass = false;
              this.createSwiper();
              //显示公告
              this.$root.eventHub.$emit("updateClassListState", false);
            }, 0);
            this.$nextTick(() => {
              this.playAmn();
            });
            this.dataState = res.map((v) => v.classId);
            if (
              this.firstLogin == 1 &&
              res.some((v) => v.experienceSubType == 26)
            ) {
              this.$emit("getListSuccess");
            }
            if (!this.interval && this.dataState.length) {
              this.interval = setInterval(
                this.getState,
                this.round_robin_interval * 1000
              );
            }
          },
          (err) => {
            this.isRequest = false;
            this.loadErrorShow = true;
            this.classList = [];
          }
        )
        .catch((err) => {
          this.isRequest = false;
          this.loadErrorShow = true;
          this.classList = [];
        });
    },
    createSwiper() {
      //创建swiper
      this.swiper = new Swiper(".swiper-box", {
        slidesPerView: "auto",
        //centeredSlides: true,
        paginationClickable: true,
        centerInsufficientSlides: true, //当slides的总数小于slidesPerView时，slides居中。
        spaceBetween: 65, //slide之间的距离
        observer: true,
        observeParents: true,
        mousewheel: true,
        on: {
          slideChangeTransitionEnd: function () {
            common.setSession("classListActiveIndex", this.activeIndex);
          },
        },
      });
    },
    swiperupdateSize() {
      //更新swiper
      if (this.swiper && this.swiper.update) {
        let index = common.getSession("classListActiveIndex") || 0;
        this.swiper.update(true);
        this.swiper.slideTo(index, 0, false);
      }
      this.hintShow = document.getElementsByClassName("show").length;
    },
    disPlayInside(index, type) {
      if (!this[type]) return true;
      if (this[type] == 1) {
        return index == 1 || index == 2;
      } else {
        return index == 3;
      }
    },
    disPlay(index, type) {
      //筛选班级
      // console.log(index,type, !this[type] || this[type]==index)
      return (
        !this[type] ||
        this[type] == "全部年份" ||
        this[type] == index ||
        (type == "gradeIndex" && this[type] == 31 && index == 32)
      );
      // return (
      //   (this.gradeIndex == 0 && this.lessonIndex == 0) ||
      //   (this.gradeIndex == 0 && this.lessonIndex == index1) ||
      //   (this.lessonIndex == 0 && this.gradeIndex == index2) ||
      //   (this.gradeIndex == index2 && this.lessonIndex == index1)
      // );
    },
    go_course(item) {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      let index = this.classList.findIndex((v) => {
        return v.classId == item.classId;
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventClassCardClicked",
        data: {
          class_Id: item.classId,
          index: 1 + index,
          count: this.classList.length,
        },
      });
      this.saveClassInfo(item);
      //进入课时列表页
      this.$router.push({ name: "course", params: { from: "class" } });
    },
    playAmn() {
      this.$nextTick(() => {
        let doms = document.querySelectorAll(".lottie_playing");
        console.log(doms, 388);
        doms.forEach((dom) => {
          if (!dom.childElementCount) {
            lottie.loadAnimation({
              container: dom,
              renderer: "svg",
              loop: true,
              autoplay: true,
              path: "/static/lottie/composeclassing.json",
            });
          }
        });
      });
    },
  },
  mounted() {
    this.playAmn();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.class_list {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  /*margin-top: -114px;*/
}

.swiper-container {
  width: 100%;
  padding: 0px 125px;
}

.swiper-wrapper {
  text-align: center;
  margin: 0 auto;
  padding-top: 10px;
}

.swiper-slide {
  width: 380px;
  height: 380px;
  // border-radius: 48px 48px 195px 195px;
  // background: rgba(255, 255, 255, 0.7);
  text-align: left;
}
.sub_slide {
  // width: 310px;
  // height: 370px;
  // border-radius: 48px 48px 195px 195px;
  // background: #ffffff;
  font-family: HYZhengYuan;
  width: 380px;
  height: 380px;
  position: relative;
  .subject-bg {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, #7bd7f6 0%, #1ea1ec 100%);
    --mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 380 380'><path fill='black' d='M0 28Q0 0 28 0H190C211 0 251 72 290 72H352Q380 72 380 100V352Q380 380 352 380H28Q0 380 0 352V28Z'/></svg>");
    -webkit-mask: var(--mask) center / 100% 100% no-repeat;
    mask: var(--mask) center / 100% 100% no-repeat;
  }
  .glow-svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    pointer-events: none;
    overflow: visible;
  }
  .title {
    padding-top: 3px;
    letter-spacing: 4px;
    height: 68px;
    font-size: 45px;
    font-weight: 800;
    line-height: 68px;
    padding-left: 32px;
    // color: #3476dd;
  }
  .grade {
    width: 90px;
    height: 42px;
    text-align: center;
    line-height: 42px;
    border-radius: 10px;
    font-size: 24px;
    background: rgba(255, 255, 255, 0.5);
  }
  .in_class {
    // width: 98px;
    // height: 67px;
    // position: absolute;
    // left: -17px;
    // top: 78px;
    // background: url(../../../assets/img/class/in_class_default.png) no-repeat;
    // background-size: 100%;
    // animation: rotateImg 1.2s infinite ease;
    position: absolute;
    left: 0px;
    top: 0;
    height: 36px;
    width: 100px;

    background: #ff657a;
    color: #ffffff;
    border-radius: 22px 0 12px 0;
    font-size: 14px;
    justify-content: center;
    display: flex;
    align-items: center;
    > span {
      height: 20px;
    }
  }
  .content {
    width: 380px;
    height: 320px;
    padding: 60px 30px 0;
    position: relative;
    // background: #ff8066;
    // border-radius: 8px 8px 190px 190px;
    margin: 0 auto;

    text-align: left;
    color: #ffffff;
    .subjectIco1,
    .subjectIco2,
    .subjectIco3,
    .subjectIco4,
    .subjectIco5 {
      // display: block;
      // margin: 0 auto;
      // width: 100%;
      // height: 188px;
      position: absolute;
      width: 250px;
      height: auto;
      top: -50px;
      right: -20px;
      z-index: 12;
    }
    .subjectIco5 {
      top: -89px;
    }
    // h2 {
    //   padding-top: 10px;
    //   white-space: nowrap;
    //   font-size: 26px;
    //   width: 75%;
    //   margin: 0 auto;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
    //   &.u-single {
    //     padding-top: 0;
    //     min-height: 29px;
    //     max-height: 58px;
    //     white-space: normal;
    //     word-break: break-all;
    //     font-size: 20px;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     display: -webkit-box;
    //     -webkit-line-clamp: 2;
    //     -webkit-box-orient: vertical;
    //   }
    // }
    .title {
      font-size: 42px;
      padding: 0;
      // font-size: 20px;
      margin: 0;
    }
    .course_title {
      margin-top: 50px;
      margin-bottom: 20px;
      font-size: 22px;
      height: 50px;
    }
    .course_info {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      padding-bottom: 20px;
    }
    p {
      padding: 0;
      display: flex;
      > img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
    span {
      opacity: 0.8;
      font-size: 14px;
    }
    .test_student {
      text-align: left;
      h2 {
        padding: 0;
        // font-size: 20px;
        margin: 0;
        &.course_title {
          margin-top: 50px;
          margin-bottom: 20px;
          font-size: 22px;
          height: 50px;
        }
        &.course_info {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          padding-bottom: 20px;
        }
      }
      p {
        padding: 0;
        display: flex;
        > img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
    }
  }
  .end {
    position: absolute;
    left: 0px;
    top: 0;
    height: 36px;
    width: 100px;
    text-align: center;
    background: #ff657a;
    color: #ffffff;
    border-radius: 22px 0 12px 0;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.subject_1 {
  .title {
    // color: #0086df;
  }
  // .grade {
  //   background: url(../../../assets/img/class/grade_bg_1.png) no-repeat;
  //   background-size: 100%;
  // }
  .in_class {
    // background: url(../../../assets/img/class/in_class_1.png) no-repeat;
    // background-size: 100%;
  }
  .content {
    // background: #49a4ff;
  }
}
.subject_2 {
  .title {
    // color: #eb8509;
  }
  .subject-bg {
    background: linear-gradient(181deg, #00826d 1%, #09d8c0 99%);
  }
  // .grade {
  //   background: url(../../../assets/img/class/grade_bg_2.png) no-repeat;
  //   background-size: 100%;
  // }
  .in_class {
    // background: url(../../../assets/img/class/in_class_2.png) no-repeat;
    // background-size: 100%;
  }
  .content {
    // background: #ffb254;
  }
}
.subject_3 {
  .title {
    // color: #8750c6;
  }
  .subject-bg {
    background: linear-gradient(180deg, #8a68f8 9%, #c09dfa);
  }
  // .grade {
  //   background: url(../../../assets/img/class/grade_bg_3.png) no-repeat;
  //   background-size: 100%;
  // }
  .in_class {
    // background: url(../../../assets/img/class/in_class_3.png) no-repeat;
    // background-size: 100%;
  }
  .content {
    // background: #9d7bf1;
  }
}
.subject_4 {
  .subject-bg {
    background: linear-gradient(178deg, #f8ac00 1%, #ffcd5b 99%);
  }
  .title {
    // color: #e3593d;
  }
}
.subject_5 {
  .title {
    // color: #009c75;
  }
  .subject-bg {
    background: linear-gradient(180deg, #32a745, #89f699);
  }
  // .grade {
  //   background: url(../../../assets/img/class/grade_bg_5.png) no-repeat;
  //   background-size: 100%;
  // }
  .in_class {
    // background: url(../../../assets/img/class/in_class_5.png) no-repeat;
    // background-size: 100%;
  }
  .content {
    // background: #14cc9e;
  }
}
.subject_6 {
  .title {
    color: #0086df;
  }
  .subject-bg {
    background: linear-gradient(180deg, #32a745, #89f699);
  }
  // .grade {
  //   background: url(../../../assets/img/class/grade_bg_1.png) no-repeat;
  //   background-size: 100%;
  // }
  .in_class {
    // background: url(../../../assets/img/class/in_class_1.png) no-repeat;
    // background-size: 100%;
  }
  .content {
    background: #49a4ff;
  }
}
.novice_class {
  .title {
    color: #009c75;
  }
  .grade {
    background: url(../../../assets/img/class/grade_bg_novice.png) no-repeat;
    background-size: 100%;
  }
  .in_class {
    background: url(../../../assets/img/class/in_class_novice.png) no-repeat;
    background-size: 100%;
  }
  .content {
    background: #14cc9e;
  }
  .content .test_student h2 {
    font-size: 26px;
    margin-top: 10px;
  }
}
.course_title {
  margin-top: 50px;
  margin-bottom: 10px;
}
.hint {
  position: absolute;
  margin-top: -150px;
  width: 100%;
  opacity: 0.75;
  color: #ffffff;
  .filter_hint {
    display: block;
    font-size: 24px;
    margin-top: 150px;
  }
  span {
    font-size: 32px;
    font-weight: normal;
    opacity: 0.75;
  }
  p {
    font-family: PingFang_Medium;
    font-size: 18px;
    margin-top: 20px;
  }
}
.opacityClass {
  opacity: 0;
  visibility: hidden;
}
.hide {
  display: none !important;
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
  display: flex;
  align-items: center;
  padding-top: 133px;
  .swiper-container {
    pointer-events: none;
    overflow: inherit;
  }
  .guide {
    color: #ffffff;
    position: absolute;
    width: 410px;
    left: 335px;
    top: 100px;
    background: url(../../../assets/img/class/guide.png) no-repeat left 18px;
    padding-left: 90px;
    background-size: 70px 33px;
    p {
      font-size: 24px;
      line-height: 40px;
    }
    button {
      color: #e8e9e9;
      font-size: 22px;
      border: 1px solid #e8e9e9;
      width: 127px;
      height: 60px;
      border-radius: 30px;
      margin-top: 30px;
      cursor: pointer;
      pointer-events: auto;
    }
  }
  .guide-top {
    top: -95px;
    left: 155px;
    background-position: left 35px;
    button {
      float: right;
    }
  }
}
.lottie_playing {
  width: 20px;
  height: 20px;
  margin-right: 3px;
}
.lottie_playing_text {
  padding-top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class_list.vue